import React from "react";
import { PromptFormPaneForm } from "./PromptFormPaneForm";
import { PromptMultiShotsField } from "./PromptFormInputs/PromptMultiShotsInputs";
import { FurtherInstructionsGpt3, PromptConfigOverwrite } from "./types";
import { isGoogle } from "./utils";

export type Props = {
  loading: boolean;
  selectedModelName: string;
  advancedParameters: {
    further_instructions: string[] | FurtherInstructionsGpt3[];
    config_overwrite: PromptConfigOverwrite;
  };
  collectAdvancedParameters: (
    parameters: Partial<{
      further_instructions: string[] | FurtherInstructionsGpt3[];
      config_overwrite: PromptConfigOverwrite;
    }>
  ) => void;
};

export const PromptFormAdvancedTab: React.FC<Props> = ({
  loading,
  selectedModelName,
  advancedParameters,
  collectAdvancedParameters,
}) => {
  const renderBody = (modelName: string): React.ReactNode => {
    return (
      <span data-testid="prompt-form-multishot-tab-inputs">
        {!isGoogle(modelName) && (
          <PromptMultiShotsField
            multiShots={advancedParameters.further_instructions as string[]}
            updateMultiShot={updateMultiShot}
            addMultiShot={addMultiShot}
            removeMultiShot={removeMultiShot}
          />
        )}
      </span>
    );
  };

  // Multi-shot
  const updateMultiShot = (index: number, value: string): void => {
    const copyMultiShots = [...advancedParameters.further_instructions];
    copyMultiShots[index] = value;
    collectAdvancedParameters({
      further_instructions: copyMultiShots as string[],
    });
  };
  const addMultiShot = (): void => {
    collectAdvancedParameters({
      further_instructions: [
        ...advancedParameters.further_instructions,
        "",
      ] as string[],
    });
  };
  const removeMultiShot = (): void => {
    const copyMultiShots = [...advancedParameters.further_instructions];
    copyMultiShots.splice(-1, 1);
    collectAdvancedParameters({
      further_instructions: copyMultiShots as string[],
    });
  };

  return (
    <PromptFormPaneForm
      isLoading={loading}
      testId="prompt-form-multishot-settings"
    >
      {renderBody(selectedModelName)}
    </PromptFormPaneForm>
  );
};
